const BUS = {
  length: 12,
  width: 2.55,
  roofY: 3.3,
  /** Bottom of the body skirt, well below hub height, so the arches are pronounced. */
  skirtY: 0.42,
  wheelRadius: 0.52,
  tyreWidth: 0.295,
  archClearance: 0.06,
  steerAxleX: 3.3,
  driveAxleX: -2.7,
  steerHalfTrack: 1.05,
  dualHalfTrack: 0.92,
  dualSpacing: 0.36,
  /** Continuous side glazing band. */
  glazing: { frontX: 5.3, rearX: -5.35, lowY: 1.62, highY: 2.68 },
  /** Shared by the body profile and the windscreen panel so the two cannot drift. */
  windscreenLower: [5.94, 2.2],
  windscreenUpper: [5.48, 3.08],
  /**
   * Passenger doors sit on the nearside. This fleet drives on the left, so the kerb —
   * and the doors — are on the vehicle's left.
   */
  doors: [
    { frontX: 4.8, rearX: 3.9 },
    { frontX: 0.6, rearX: -0.5 }
  ]
};
const BUS_NOSE_X = BUS.length / 2;
const BUS_TAIL_X = -BUS_NOSE_X;
const BUS_ARCH_RADIUS = BUS.wheelRadius + BUS.archClearance;
export {
  BUS,
  BUS_ARCH_RADIUS,
  BUS_NOSE_X,
  BUS_TAIL_X
};
